<template>
  <tfoot v-if="rows.length > 0">
    <tr style="background-color: #f2f2f28e">
      <td class="text-center p-3">
        <strong style="font-size: 16px">{{
          getSizeRows > 10 && rows.length > 0
            ? $t('common_words.sub_total')
            : $t('common_words.total_mayus')
        }}</strong>
      </td>
      <template v-for="(ribbonData, week) in columns">
        <template v-for="ribbon in ribbonData">
          <td class="text-center">
            <strong style="font-size: 16px">
              {{ getTotalColumn(week, ribbon) }}
            </strong>
          </td>
        </template>
      </template>
      <td class="text-center">
        <strong style="font-size: 16px">{{ getTotal() }}</strong>
      </td>
    </tr>
    <tfoot-totals-by-age-week
      v-if="getSizeRows > 10 && rows.length > 0"
      :totalColumns="totalColumns"
      :columns="columns"
      :option="option"
    />
  </tfoot>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import TfootTotalsByAgeAndWeek from './TfootTotalsByAgeAndWeek.vue';

export default {
  name: 'tfoot-by-age-week',
  components: {
    [TfootTotalsByAgeAndWeek.name]: TfootTotalsByAgeAndWeek,
  },
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    totalRows: {
      type: Array | Object,
      default: [],
    },
    totalColumns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'reportByAgeAndWeek',
    },
  },
  computed: {
    getSizeRows() {
      return Object.values(this.totalRows).length;
    },
  },
  mixins: [MixinMasters],
  methods: {
    getTotalColumn(week, ribbon) {
      const result = this.rows
        .map((item) => item.numberLot)
        .map((numberLot) => {
          try {
            const filtered =
              this.totalColumns['cutting'][week][ribbon.color_name][numberLot];
            return Array.isArray(filtered)
              ? getSumOfValorFromArray(filtered)
              : filtered;
          } catch (error) {
            return [];
          }
        });

      let sum = getSumOfValorFromArray(result);
      return sum > 0 ? Formatter.formatNumber(sum) : 0;
    },
    getTotal() {
      let total = 0;
      if (this.rows.length === 0) return '';
      const rowsTemp = [];
      Object.entries(this.totalRows).forEach((totalColumns) =>
        rowsTemp.push(totalColumns[1])
      );

      const result = this.rows
        .map((item) => item.index)
        .map((index) => rowsTemp[index]);

      result.forEach((row) => {
        let sum = 0;
        try {
          sum = getSumOfValorFromArray(row);
        } catch (error) {}
        total += sum;
      });

      return total > 0 ? Formatter.formatNumber(total) : 0;
    },
  },
};
</script>
